export default {
  namespaced: true,
  state: {
    routes: JSON.parse(sessionStorage.getItem('h5_vue_nav') || '[]') || [],
  },
  mutations: {
    forward(state, name) {
      state.routes.push(name)
      sessionStorage.h5_vue_nav = JSON.stringify(state.routes)
    },
    back(state, count) {
      state.routes.splice(state.routes.length - count, count)
      sessionStorage.h5_vue_nav = JSON.stringify(state.routes)
    },
    replace(state, name) {
      state.routes.splice(state.routes.length - 1, 1, name)
      sessionStorage.h5_vue_nav = JSON.stringify(state.routes)
    },
  },
}
